import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RequirementTypeEnumDTO from 'features/requirements/dtos/RequirementTypeEnumDTO';
import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import RequirementType from './RequirementType';
import styles from './requirementtypegroup.module.scss';

interface Props {
  name: string;
  types: RequirementTypeEnumDTO[];
  closeDialogHandler: () => void;
}

const RequirementTypeGroup = ({ name, types, closeDialogHandler }: Props) => {
  // state
  const [openGroup, setOpenGroup] = useState(false);

  // helpers
  const toggleOpenClass = (): string => {
    return openGroup ? ` ${styles.open}` : "";
  }

  // handlers
  const toggleGroupHandler = () => {
    setOpenGroup(!openGroup)
  }

   // sub-renders
  const renderRequirementTypes = () => {
    return (
      types.map((type) => (
        <RequirementType
          type={type}
          handleCloseDialog={closeDialogHandler}
          key={type.code}
        />
      ))
    );
  }

  // render
  return (
    <div className={`card mb-2${toggleOpenClass()}`}>
      <div className={`card-header py-2 ${styles.header}`} role="button" onClick={toggleGroupHandler}>
        <div className="d-flex align-items-center">
          <span className="mr-3">{name}</span>
          <span className="text-muted ml-auto">
            <span className={styles.headerArrow}>
              <FontAwesomeIcon icon="chevron-down" size="sm" />
            </span>
          </span>
        </div>
      </div>
      <Collapse in={openGroup}>
        <div>
          <ul className={`list-group list-group-flush border-top ${styles.list}`}>
            {renderRequirementTypes()}
          </ul>
        </div>
      </Collapse>
    </div>
  )
}

export default RequirementTypeGroup;
